export default {
  VIEW_HOME: 'View Home',
  // Canon Products
  VIEW_CANON_PRODUCT_LIST: 'View Canon Products List', // View Canon Product List
  VIEW_CANON_PRODUCT: 'View Canon Product', // 'View Canon Product
  ADD_CANON_PRODUCT: 'Add Canon Product', // Add Canon Product
  EDIT_CANON_PRODUCT: 'Edit Canon Product', // Edit Canon Product
  DELETE_CANON_PRODUCT: 'Delete Canon Product', // Delete Canon Product 
  RECOVER_CANON_PRODUCT: 'Recover Canon Product', // Delete Canon Product
  IMPORT_CANON_PRODUCT: 'Import Canon Products', // Import Canon Product
  EXPORT_CANON_PRODUCT: 'Export Canon Products', // Export Canon Product
  MANAGE_CANON_PRODUCT_SERIAL: 'Manage Serial Numbers', // Manage Canon Product Serial Numbers,
  // QR / Pin Code
  VIEW_PIN_CODE_LIST: 'View QR Code / PIN Code List', // View QR/PIN Code List
  ADD_PIN_CODE: 'Add QR Code / PIN Code', // Add QR/PIN Code
  EDIT_PIN_CODE: 'Edit QR Code / PIN Code', // Edit QR/PIN Code
  DELETE_PIN_CODE: 'Delete QR Code / PIN Code', // Delete QR/PIN Code 
  RECOVER_PIN_CODE: 'Recover QR Code / PIN Code', // Recover QR/PIN Code
  IMPORT_PIN_CODE: 'Import QR Code / PIN Code', // Import QR/PIN Code
  EXPORT_PIN_CODE: 'Export QR Code / PIN Code', // Export QR/PIN Code
  // Promo
  VIEW_PROMO_LIST: 'View Promos List', // View Promo List
  VIEW_PROMO: 'View Promo', // View Promo
  ADD_PROMO: 'Add Promo', // Add Promo
  EDIT_PROMO: 'Edit Promo', // Edit Promo
  IMPORT_PROMO: 'Import Promo', // Import Promo
  EXPORT_PROMO: 'Export Promo', // Export Promo
  ACTIVATE_PROMO: 'Activate Promo', // Activate Promo
  HOLD_PROMO: 'Hold Promo', // Hold Promo
  // Promo - Ads
  VIEW_ADVERTISEMENT_LIST: 'View Ads List', // View Ads List
  VIEW_ADVERTISEMENT: 'View Ad', // View Ads
  ADD_ADVERTISEMENT: 'Add Ad', // Add Ads
  EDIT_ADVERTISEMENT: 'Edit Ad', // Edit Ads
  DELETE_ADVERTISEMENT: 'Delete Ad', // Edit Ads
  RECOVER_ADVERTISEMENT: 'Recover Ad', // Recover Ads
  IMPORT_ADVERTISEMENT: 'Import Ad', // Import Ads
  EXPORT_ADVERTISEMENT: 'Export Ad', // Export Ads
  // Rewards
  VIEW_REWARD_LIST: 'View Rewards List', // View Reward List
  EXPORT_REWARD: 'Export Reward', // View Reward List
  // Service Center
  VIEW_SERVICE_CENTER_LIST: 'View Service Centers List', // View Service Center List
  VIEW_SERVICE_CENTER: 'View Service Center', 
  EDIT_SERVICE_CENTER:  'Update Service Center',
  DELETE_SERVICE_CENTER: 'Delete Service Center',
  IMPORT_SERVICE_CENTER: 'Import Service Center',
  EXPORT_SERVICE_CENTER: 'Export Service Center',
  // User Management ---
  // Customer
  VIEW_CUSTOMER_LIST: 'View Customer List',
  VIEW_CUSTOMER: 'View Customer', // View Customer
  ADD_CUSTOMER: 'Add Customer',
  EDIT_CUSTOMER: 'Edit Customer',
  DELETE_CUSTOMER: 'Delete Customer',
  EXPORT_CUSTOMER: 'Export Customer',
  IMPORT_CUSTOMER: 'Import Customer',
  // Admin
  VIEW_ADMIN_LIST: 'View Admin List',
  VIEW_ADMIN: 'View Admin', // View Admin
  ADD_ADMIN: 'Add Admin',
  EDIT_ADMIN: 'Edit Admin',
  DELETE_ADMIN: 'Delete Admin',
  IMPORT_ADMIN: 'Import Admin',
  EXPORT_ADMIN: 'Export Admin',
  // Roles
  VIEW_ROLE_LIST: 'View Role List',
  ADD_ROLE: 'Add Role',
  EDIT_ROLE: 'Edit Role',
  DELETE_ROLE: 'Delete Role',
  // Settings ---
  // Archive
  VIEW_ARCHIVE_LIST: 'View Archive List', // View Archive List
  VIEW_ARCHIVE: 'View Archive',
  EXPORT_ARCHIVE: 'Export Archive',
  // CMS
  VIEW_CMS_PAGES: 'View About Us', // View CMS Pages
  VIEW_ABOUT_US: 'View About Us',
  VIEW_FAQ: 'View FAQ', // View Canon PH App Questions
  VIEW_PRIVACY_POLICY: 'View Privacy Policy',
  VIEW_TERMS_AND_CONDITIONS: 'View Terms And Conditions',
  // Activity Log
  VIEW_ACTIVITY_LOGS_LIST: 'View Activity Logs List', // View Activity Logs
  EXPORT_ACTIVITY_LOGS: 'Export Activity Logs', // Export Activity Logs
  // Approval Access
  VIEW_APPROVAL_ACCESS: 'View Approval Access', // View Approval Access
  // Download Log
  VIEW_DOWNLOAD_LOGS_LIST: 'View User Download Logs List', // View Activity Logs
  EXPORT_DOWNLOAD_LOGS: 'Export User Download Logs', // Export Activity Logs
  
  // CMP Registration
  VIEW_CMP_REGISTRATION_LIST: 'View CMP Product Registrations List', // View CMP Registration List
  VALIDATE_CMP_REGISTRATION: 'Validate Registration',
  AWARD_CMP_REGISTRATION: 'Award Registration',
  APPROVAL_CMP_REGISTRATION: 'Approval Registration',
  APPROVED_CMP_REGISTRATION: 'Approved Registration',
  REJECTED_CMP_REGISTRATION: 'Rejected Registration',
  IMPORTED_CMP_REGISTRATION: 'Imported Registrations',
  VIEW_CMP_REGISTRATION: 'View CMP Product Registration', // View CMP Registration
  ADD_CMP_REGISTRATION: 'Add CMP Product Registration', // Add CMP Registration
  EDIT_CMP_REGISTRATION: 'Edit CMP Product Registration', // Edit CMP Registration
  REJECT_CMP_REGISTRATION: 'Reject CMP Product Registration',
  IMPORT_CMP_REGISTRATION: 'Import CMP Product Registration', // Edit CMP Registration
  EXPORT_CMP_REGISTRATION: 'Export CMP Product Registration', // Edit CMP Registration

  // Student Promo
  VALIDATE_STUDENT_REGISTRATION: 'Validate Student Registration', // Request Proof of Enrollment
  VIEW_STUDENT_INFORMATION: 'View Student Information', // View Student Information
  REJECT_STUDENT_REGISTRATION: 'Reject Student Registration', // Reject Student Registration
  STUDENT_PROMO: 'Student Promo',

  // Non CMP Registration
  VIEW_NONCMP_REGISTRATION_LIST: 'View Non CMP Product Registrations List', // View Non CMP Registration List
  VIEW_NONCMP_REGISTRATION: 'View Non CMP Product Registration', // View Non CMP Registration
  EDIT_NONCMP_REGISTRATION: 'Edit Non CMP Product Registration', // View Non CMP Registration
  DELETE_NONCMP_REGISTRATION: 'Delete Non CMP Product Registration', // View Non CMP Registration
  VALIDATE_NONCMP_REGISTRATION: 'Validate Non CMP Product Registration', // View Non CMP Registration
  EXPORT_NONCMP_REGISTRATION: 'Export Non CMP Product Registration', // View Non CMP Registration
  // Product Repair
  VIEW_PRODUCT_REPAIR_LIST: 'View Product Repair List', // View Product Repair List
  VIEW_PRODUCT_REPAIR: 'View Product Repair', // View Product Repair
  ADD_PRODUCT_REPAIR: 'Add Product Repair', // Add Product Repair
  EDIT_PRODUCT_REPAIR: 'Edit After-Sales Services', // Edit Product Repair
  IMPORT_PRODUCT_REPAIR: 'Import Product Repair', // Import Product Repair
  EXPORT_PRODUCT_REPAIR: 'Export Product Repair', // Export Product Repair
  // Warranty
  VIEW_WARRANTY_LIST: 'View Warranty List', // View Warranty List
  VIEW_WARRANTY: 'View Warranty', // View Warranty
  ADD_WARRANTY: 'Add Warranty', // Add Warranty
  EDIT_WARRANTY: 'Edit Warranty', // Edit Warranty
  APPROVE_WARRANTY: 'Approve Warranty', // Approve Warranty
  REJECT_WARRANTY: 'Reject Warranty', // Reject Warranty
  EXPORT_WARRANTY: 'Export Warranty', // Edit Warranty
  IMPORT_WARRANTY_CONTRACTS: 'Import Contracts', // Edit Warranty
  IMPORT_WARRANTY_SERVICE_ENTRIES: 'Import Service Entries', // Edit Warranty
  // Customer Support 
  VIEW_CUSTOMER_SUPPORT: 'View Customer Support',
  VIEW_NOTIFICATION_LIST: 'View Notifications List',// View Notification List
  ADD_NOTIFICATION: 'View Notifications', // Add Notification
  EDIT_NOTIFICATION: 'View Notifications', // Edit Notification

  VIEW_ALL_NOTIFICATION: 'View All Notifications',// View All Notifications
}